import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import SubscriptionTable from "./SubscriptionTable";

const Subscription = () => {
    return (
        <Fragment>
            <SubscriptionTable mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default Subscription;